import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { IProposition, IUser } from 'src/model';
import { EvaluationPropositionCardWithGlobalContext } from './EvaluationProposition/EvaluationPropositionCard';
import { EvaluationPropositionEditionWithGlobalContext } from './EvaluationProposition/EvaluationPropositionEdition';

interface IProjectEvaluationProps {
  consultant: IUser;
  proposition: IProposition;
}

export const ProjectEvaluation: React.SFC<IProjectEvaluationProps> = ({
  consultant,
  proposition,
}) => (
  <>
    <Row className='p-5'>
      <Col md='12'>
        <EvaluationPropositionCardWithGlobalContext proposition={proposition} />
      </Col>
    </Row>
    <EvaluationPropositionEditionWithGlobalContext
      consultant={consultant}
      proposition={proposition}
    />
  </>
);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectEvaluation/ProjectEvaluation.tsx